
import { Component, Vue, Prop } from 'vue-property-decorator';
import { setTimeout } from 'timers';

@Component
export default class BounceInTransition extends Vue {
    @Prop() delay: number;
    @Prop() animateUntilIndex: number;

    beforeEnter(element: HTMLElement) {
        if (this.animateElement(element)) {
            element.classList.add('bounce-list-enter');
        }
    }

    appear(element: HTMLElement) {
        if (this.animateElement(element)) {
            const delay = parseInt((element.dataset as any).index) * (this.delay || 150);
            this.bounceElementIn(element, delay);
        }
    }

    enter(element: HTMLElement) {
        this.bounceElementIn(element, 0);
    }

    bounceElementIn(element: HTMLElement, delay: number) {
        setTimeout(() => {
            element.classList.add('bounce-list-enter-active');
            // Class can be removed as animation is still going.
            element.classList.remove('bounce-list-enter');
            setTimeout(() => element.classList.remove('bounce-list-enter-active'), 500);
        }, delay);
    }

    leave(element: HTMLElement, done: () => void) {
        element.classList.add('bounce-list-leave-active');
        element.classList.add('bounce-list-leave-to');
        setTimeout(() => done(), 300);
    }

    private animateElement(element: HTMLElement) {
        const index = parseInt((element.dataset as any).index);
        return index <= (this.animateUntilIndex || 5); // Only animate 5 elements by default.
    }
}
